export default __webpack_public_path__ + "static/media/icon-plus.0c864b70.svg";